module.exports = __webpack_public_path__ + "img/instrucciones-faqs.6f4c660b.png";